export default function (appType) {
  return appType?.Value === 1 || appType?.Value === 2;
}
